import { Component, AfterViewInit } from '@angular/core';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';
import { Router } from '@angular/router';
import { CookieStorage } from '../../shared/services/cookie-storage/cookie-storage.service';
import { UserRulesService } from 'src/app/shared/services/user-rules.service';

@Component({
  selector: 'app-sign-in-redirect',
  templateUrl: './sign-in-redirect.component.html',
  styleUrls: ['./sign-in-redirect.component.scss']
})
export class SignInRedirectComponent implements AfterViewInit {

  constructor(private auth: OidcClientService, private router: Router, private storage: CookieStorage,
              private rules: UserRulesService) { }

  ngAfterViewInit() {
    if(!this.auth.inIframe()) {
      this.auth.getUserComputed().subscribe(user => {
        if(user) {
          if(this.auth.isExpired()) {
            this.auth.userManager.removeUser().then(() => {
              this.auth.switchToCookieStorage();
              this.auth.signIn();
            });
          } else {
            this.router.navigateByUrl('');
          }
        } else {
          this.auth.completeSignIn().subscribe(signedInUser => {
            if(signedInUser) {
              this.rules.setPrimaryIdFromProfile(signedInUser.profile);
              if(sessionStorage.getItem('querymember')) {
                this.rules.setSecondaryId(sessionStorage.getItem('querymember'));
                this.rules.setIdToken(signedInUser.id_token);
              } else {
                this.rules.updateRecipientStatus(signedInUser.id_token).subscribe(() => {
                  const route = this.storage.getItem('intended-route');
                  if(route) {
                    this.storage.removeItem('intended-route');
                    this.router.navigateByUrl(route);
                  } else {
                    this.router.navigateByUrl('');
                  }
                });
              }
            }
          },
          error => {
            this.auth.signIn();
          });
        }
      });
    }
  }
}
